export class DomainError extends Error {
  constructor(
    message: string,
    public readonly context?: Record<string, unknown>
  ) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class NotFoundError extends DomainError {}
export class ValidationError extends DomainError {}
export class InfrastructureError extends DomainError {
  constructor(
    message: string,
    public readonly originalError?: Error
  ) {
    super(message);
  }
}
